const BASE_URL = "https://swip4winapiv1.bngrenew.com:5081/swipe4win/libly";

const apiUrl = {
  AUTH: BASE_URL + "/authorization",
  LOGIN: BASE_URL + "/v2/login",
  ANTIFRAUD:BASE_URL + "/getApi/v1/protected-script",
  SUBSCRIBER_DETAILS : BASE_URL + "/subscriber-details",
  SUBSCRIBER_TRANSACTIONS : BASE_URL + "/subscriber-details?",
  SUBS_ACTIVATION: BASE_URL+ "/subscription-activation",
  UNSUBSCRIBE : BASE_URL +'/unsubscribe',
  UNSUB_CONFIRM : BASE_URL + "/unsubscribe-confirm",
  DIRECT_UNSUB : BASE_URL + "/direct-unsubscribe",
  SUBS_LIST : BASE_URL + "/subscription-list",
  UPGRADE: BASE_URL + "/upgrade",
  UPGRADE_CONFIRM : BASE_URL + "/upgrade-confirm",
  LOGIN_CONFIRM: BASE_URL + "/login-confirm",
  SUBS_ACTIVATE_CONFIRM: BASE_URL + "/subscription-activation-confirm",
  CHECKSUB : "https://swip4winapiv1.bngrenew.com:5081/swipe4win/user/subscription",
  SUBSCRIBE: "https://swip4winapiv1.bngrenew.com:5081/swipe4win/subscribe",
  REGISTER : "https://swip4winapiv1.bngrenew.com:5081/swipe4win/register"
};

const HEADERS = {
  Authorization: sessionStorage.getItem("authToken") || 'na',
  "Content-Type": "application/json",
  accept: "application/json",
};

const email = "api-daretoknow@zainlibya.ly";
const password = "D@re&15Kn";
const countryCode = "+218";
const opeartorId = "zainlibyanaop"

const normalizeOperator = (value) => {
  if (!value) return null;
  const lower = String(value).trim().toLowerCase();
  if (lower === "madar") return "madar";
  if (lower === "libyana") return "libyana";
  return null;
};

const getOperatorFromSubServiceId = (subServiceId) => {
  if (!subServiceId) return null;
  const lastWord = String(subServiceId).trim().split(/\s+/).pop();
  return normalizeOperator(lastWord);
};

export {
  HEADERS,
  countryCode,
  apiUrl,
  email,
  password,
  opeartorId,
  getOperatorFromSubServiceId,
  normalizeOperator,
};
